export enum FilterActions {
  UPDATE_CURRICULA_SELECTED = 'updateCurriculaSelected',
  UPDATE_COURSES_SELECTED = 'updateCoursesSelected',
  UPDATE_CURRICULA_LIST = 'updateCurriculaList',
  UPDATE_COURSES_LIST = 'updateCoursesList',
  ADD_CONTENT_ITEM = 'addContentItem',
  OPEN_ACCORDION = 'openAccordion',
  CLOSE_ACCORDION = 'closeAccordion',
  SET_LOADING_INDICATOR = 'setLoadingIndicator',
}